import * as React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { resetPasswordWithTokenAsync } from '../../ajax/requests';
import { paths } from '../../app/constants';
import TurnstileWidget from '../../components/TurnstileWidget';

const ResetPasswordAction: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        if (!token) {
            window.location.href = paths.actionResult() + '#newPasswordNotGenerated';
            return;
        }

        resetPasswordWithTokenAsync(token)
            .then(() => {
                window.location.href = paths.actionResult() + '#newPasswordSent';
            })
            .catch(() => {
                window.location.href = paths.actionResult() + '#newPasswordNotGenerated';
            });
    }, [location.search]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Spinner color="primary" />
            <TurnstileWidget />
        </div>
    );
};

export default ResetPasswordAction;
